import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punedarshansedancabbooking() {



  const cardData = {




keyword: "Pune Darshan Sedan Cab Booking",

headingDescription: "Garud Cab Service provides comfortable Pune Darshan Sedan Cab Booking for travelers, families, couples, senior citizens, and visitors who want to explore Pune's historic landmarks, temples, cultural attractions, shopping areas, and popular city destinations. Our chauffeur-driven sedan cars are suitable for local sightseeing, family outings, half-day tours, full-day Pune Darshan, and customized city travel plans. With clean and well-maintained vehicles, experienced local drivers, convenient pickup and drop facilities, flexible sightseeing schedules, transparent pricing, and 24/7 customer assistance, Garud Cab Service makes Pune city exploration comfortable and convenient. Customers can select their preferred attractions and create a personalized Pune Darshan itinerary according to their available time.",

topPlaces: [
  {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is one of Pune's most famous historical landmarks and an important attraction for visitors interested in Maratha history and architecture. The historic fort complex offers travelers an opportunity to explore the heritage of Peshwa-era Pune and its surrounding old-city areas. A chauffeur-driven sedan makes it convenient for families and visitors to reach Shaniwar Wada comfortably as part of a customized Pune Darshan itinerary."
  },
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is a significant historical landmark in Pune known for its impressive architecture, spacious gardens, and association with India's freedom movement. The palace provides an interesting combination of history, heritage, and peaceful surroundings. Visitors can include it in their Pune Darshan plan and travel comfortably between this attraction and other city sightseeing locations in a private sedan."
  },
  {
    title: "Sinhagad Fort",
    description: "Sinhagad Fort is a popular hilltop attraction near Pune offering panoramic views of the surrounding Sahyadri landscape and an important connection with Maratha history. It is a favorite destination for families, history enthusiasts, and visitors looking for scenic views. Garud Cab Service provides private sedan transportation for travelers who want to include Sinhagad in a customized Pune sightseeing route."
  },
  {
    title: "Dagdusheth Halwai Ganpati Temple",
    description: "Dagdusheth Halwai Ganpati Temple is one of Pune's best-known religious landmarks and attracts devotees and visitors throughout the year. The temple is located in the heart of the city and is an important stop for travelers exploring Pune's cultural and spiritual heritage. A sedan cab provides convenient transportation for families and senior citizens visiting the temple along with other nearby attractions."
  },
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut temple located in central Pune and dedicated to Lord Shiva. Its carved stone structures and peaceful temple surroundings offer visitors a glimpse into the city's historical and religious heritage. Travelers booking a Pune Darshan sedan can comfortably include Pataleshwar along with other central Pune attractions in their sightseeing itinerary."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum houses a large collection of traditional Indian art, sculptures, decorative objects, musical instruments, and historic artifacts. It is an excellent destination for travelers interested in Indian culture and heritage. Garud Cab Service can arrange a comfortable sedan for visitors who want to explore the museum along with other cultural attractions during their Pune Darshan."
  },
  {
    title: "Parvati Hill",
    description: "Parvati Hill is a well-known Pune landmark offering city views along with historic temples and a peaceful hilltop atmosphere. The location is particularly attractive for visitors interested in temples, photography, and panoramic views of Pune. A private sedan allows families and senior travelers to conveniently reach the area and continue to other sightseeing destinations according to their schedule."
  },
  {
    title: "Pashan Lake",
    description: "Pashan Lake is a peaceful natural attraction in Pune known for its greenery, walking surroundings, birdlife, and relaxing atmosphere. It provides a quieter alternative to the city's busy historical and commercial areas and can be included in a customized city tour. Travelers can book a sedan cab to combine Pashan Lake with nearby residential, business, and sightseeing locations."
  },
  {
    title: "Empress Garden",
    description: "Empress Garden is a historic green space in Pune offering landscaped areas, mature trees, flowering plants, and a pleasant environment for a relaxed outing. It is suitable for families and visitors who want to include a peaceful garden stop during their Pune Darshan. Garud Cab Service provides convenient sedan transportation between Empress Garden and other attractions across the city."
  },
  {
    title: "National Defence Academy View Area",
    description: "The National Defence Academy region near Khadakwasla is known for its scenic surroundings, nearby hills, and views around the Khadakwasla area. While access to restricted academy premises is controlled, visitors can enjoy permitted viewpoints and nearby attractions. A private sedan makes it convenient to include the Khadakwasla side of Pune in a customized sightseeing itinerary."
  }
],




"services": [
{
"name": "Pune Darshan Sedan Cab Booking",
"description": "Book Pune Darshan Sedan Cab Booking for a comfortable and convenient city sightseeing experience with professional chauffeurs and well-maintained air-conditioned sedans. The service is suitable for families, couples, tourists, senior passengers, and visitors planning to explore Pune's temples, historical attractions, cultural landmarks, and popular tourist places."
},
{
"name": "Pune Darshan Sedan Cab",
"description": "Choose Pune Darshan Sedan Cab for private and comfortable sightseeing across Pune with an experienced chauffeur. Enjoy AC interiors, comfortable seating, convenient pickup, and flexible travel arrangements for visiting temples, forts, museums, historical locations, markets, and other attractions during your Pune Darshan."
},
{
"name": "Pune Sightseeing Sedan Cab",
"description": "Book Pune Sightseeing Sedan Cab for a relaxed city tour covering multiple attractions according to your preferred itinerary. Comfortable sedans with professional drivers are suitable for families, couples, tourists, and small groups looking for private transportation with flexible sightseeing stops throughout Pune."
},
{
"name": "Pune City Tour Sedan Cab",
"description": "Reserve Pune City Tour Sedan Cab for convenient private transportation while exploring Pune's major landmarks and attractions. Enjoy comfortable AC travel, experienced chauffeur service, flexible pickup and drop facilities, and an itinerary that can be planned around temples, historical sites, shopping areas, and tourist destinations."
},
{
"name": "Pune Darshan Taxi Booking",
"description": "Make Pune Darshan Taxi Booking for a convenient and private city sightseeing journey with professional chauffeur service. The taxi is suitable for families, tourists, couples, senior citizens, and visitors who want comfortable transportation between Pune temples, historical attractions, cultural landmarks, and popular sightseeing locations."
},
{
"name": "Sedan Cab for Pune Darshan",
"description": "Hire Sedan Cab for Pune Darshan for comfortable sightseeing with an experienced chauffeur and clean air-conditioned vehicle. Enjoy convenient pickup, spacious seating, practical luggage capacity, and flexible travel arrangements for families and tourists visiting Pune's temples, forts, museums, gardens, and historical places."
},
{
"name": "Pune Tourist Sedan Cab Service",
"description": "Choose Pune Tourist Sedan Cab Service for reliable private transportation while exploring Pune and nearby tourist attractions. Comfortable sedans with professional chauffeurs provide convenient travel for families, couples, small groups, and visitors planning sightseeing tours, temple visits, historical exploration, and customized city trips."
},
{
"name": "Pune One Day Tour Sedan Cab",
"description": "Book Pune One Day Tour Sedan Cab for a full-day sightseeing experience with private transportation and flexible itinerary planning. Travel comfortably between multiple attractions with an experienced chauffeur while enjoying AC interiors, convenient pickup, comfortable seating, and suitable arrangements for families, tourists, and small groups."
},
{
"name": "Pune Temple Darshan Sedan Cab",
"description": "Reserve Pune Temple Darshan Sedan Cab for convenient transportation to temples and religious destinations across Pune. The private AC sedan provides comfortable travel for families, senior passengers, devotees, and tourists with flexible pickup, waiting, and drop arrangements according to the planned temple itinerary."
},
{
"name": "Pune Family Tour Sedan Cab",
"description": "Choose Pune Family Tour Sedan Cab for a comfortable private sightseeing journey designed for families traveling across Pune. Enjoy spacious seating, air-conditioned interiors, professional chauffeur service, and flexible sightseeing arrangements for visiting temples, gardens, historical landmarks, museums, and family-friendly attractions."
},
{
"name": "Pune Tourist Places Sedan Cab",
"description": "Book Pune Tourist Places Sedan Cab for convenient transportation to popular sightseeing destinations across Pune. The service offers comfortable AC travel with a professional chauffeur and flexible stops, making it suitable for tourists, families, couples, and small groups exploring historical, cultural, religious, and recreational attractions."
},
{
"name": "Pune Private Sedan Cab Booking",
"description": "Make Pune Private Sedan Cab Booking for a personalized city sightseeing journey without sharing the vehicle with other passengers. Enjoy direct pickup, comfortable AC interiors, professional chauffeur service, and flexible travel timing for Pune Darshan, sightseeing, family tours, business visits, and personal travel."
},
{
"name": "Pune Full Day Sedan Cab Service",
"description": "Book Pune Full Day Sedan Cab Service for private transportation throughout a planned day of sightseeing and local travel. Enjoy flexible pickup and drop arrangements, comfortable AC seating, professional chauffeur service, and convenient access to multiple Pune attractions, temples, historical locations, and tourist destinations."
},
{
"name": "Pune Weekend Sightseeing Sedan Cab",
"description": "Choose Pune Weekend Sightseeing Sedan Cab for a comfortable private city tour during weekends and holidays. The service is suitable for families, couples, friends, and tourists who want to explore Pune attractions with flexible sightseeing stops, convenient pickup, AC comfort, and an experienced chauffeur."
},
{
"name": "Pune Darshan Cab Service",
"description": "Reserve Pune Darshan Cab Service for dependable private transportation across Pune's temples, historical landmarks, cultural attractions, and popular sightseeing locations. Enjoy comfortable AC travel, professional chauffeur service, convenient pickup, and flexible routing suitable for families, tourists, senior passengers, and groups."
},
{
"name": "Pune Sightseeing Taxi Service",
"description": "Book Pune Sightseeing Taxi Service for comfortable and convenient transportation between multiple tourist attractions across Pune. Professional chauffeurs provide private AC travel with flexible sightseeing stops, making the service suitable for tourists, families, couples, senior travelers, and small groups planning a customized city tour."
},
{
"name": "Pune City Tour Cab Booking",
"description": "Make Pune City Tour Cab Booking for a private and comfortable sightseeing journey with scheduled pickup and convenient destination drops. Choose a suitable sedan for exploring temples, forts, museums, gardens, markets, historical landmarks, and other attractions according to your preferred city tour itinerary."
},
{
"name": "Pune Tourist Cab Service",
"description": "Choose Pune Tourist Cab Service for reliable chauffeur-driven transportation throughout your Pune sightseeing itinerary. Comfortable AC vehicles provide convenient access to tourist attractions, temples, historical sites, cultural destinations, and shopping areas while offering flexible travel arrangements for families and visitors."
},
{
"name": "Pune Sedan Taxi Service",
"description": "Book Pune Sedan Taxi Service for comfortable private transportation across the city with professional chauffeurs and well-maintained air-conditioned sedans. The service is suitable for local sightseeing, airport transfers, business visits, family travel, hotel transfers, Pune Darshan, and customized tourist itineraries."
},
{
"name": "Maruti Suzuki Dzire for Pune Darshan",
"description": "Hire Maruti Suzuki Dzire for Pune Darshan for an economical and comfortable sightseeing experience with a professional chauffeur. The AC sedan is suitable for couples, families, and small groups visiting temples, forts, museums, gardens, historical landmarks, and other popular attractions across Pune."
},
{
"name": "Hyundai Aura for Pune Darshan",
"description": "Choose Hyundai Aura for Pune Darshan for comfortable private city sightseeing with air-conditioned interiors and professional chauffeur service. The sedan provides convenient seating and practical luggage space for families, couples, tourists, and visitors exploring Pune's religious, historical, cultural, and recreational attractions."
},
{
"name": "Honda Amaze for Pune Darshan",
"description": "Book Honda Amaze for Pune Darshan for a smooth and comfortable sightseeing journey with a professional driver. The AC sedan is suitable for families, couples, senior passengers, and tourists looking for private transportation to Pune temples, historical landmarks, tourist places, shopping areas, and cultural attractions."
},
{
"name": "Sedan Taxi for Pune Sightseeing",
"description": "Reserve Sedan Taxi for Pune Sightseeing for convenient private transportation between multiple attractions according to your planned itinerary. Enjoy comfortable AC travel, professional chauffeur service, flexible pickup, and sightseeing stops suitable for families, couples, tourists, and small groups exploring Pune."
},
{
"name": "AC Sedan Cab for Pune Tour",
"description": "Book AC Sedan Cab for Pune Tour for a comfortable city sightseeing experience in a clean and air-conditioned vehicle. Professional chauffeurs provide convenient transportation for families, tourists, couples, and small groups visiting temples, historical places, museums, gardens, and other attractions."
},
{
"name": "Budget Sedan Cab Pune Darshan",
"description": "Choose Budget Sedan Cab Pune Darshan for an economical private sightseeing option with comfortable AC travel and professional chauffeur service. The sedan is suitable for individuals, couples, families, and tourists looking for practical transportation to explore Pune's temples, tourist attractions, historical sites, and local landmarks."
},
{
"name": "Premium Sedan Taxi Pune",
"description": "Reserve Premium Sedan Taxi Pune for a more comfortable and refined sightseeing experience with professional chauffeur service and well-maintained AC interiors. The service is suitable for tourists, corporate visitors, families, couples, and guests who prefer convenient private transportation during their Pune city tour."
},
{
"name": "Executive Sedan Cab Pune",
"description": "Book Executive Sedan Cab Pune for comfortable chauffeur-driven transportation suitable for business travelers, corporate guests, tourists, and families. Enjoy clean AC interiors, comfortable seating, convenient pickup, and flexible travel arrangements for Pune Darshan, sightseeing, meetings, hotel transfers, and city tours."
},
{
"name": "Sedan Cab for Family Tour Pune",
"description": "Choose Sedan Cab for Family Tour Pune for comfortable and private transportation while exploring Pune with your family. The service provides AC comfort, convenient pickup, professional chauffeur assistance, and flexible sightseeing stops for temples, museums, gardens, historical landmarks, and family-friendly tourist attractions."
},
{
"name": "Sedan Cab for Tourist Places Pune",
"description": "Book Sedan Cab for Tourist Places Pune for convenient private travel to popular attractions across the city. Enjoy comfortable AC seating and professional chauffeur service while visiting historical sites, temples, museums, gardens, cultural landmarks, markets, and other tourist destinations according to your itinerary."
}
],
"tableData": [
["Pune Darshan Sedan Cab Booking", "Pune Darshan Sedan Cab"],
["Pune Sightseeing Sedan Cab", "Pune City Tour Sedan Cab"],
["Pune Darshan Taxi Booking", "Sedan Cab for Pune Darshan"],
["Pune Tourist Sedan Cab Service", "Pune One Day Tour Sedan Cab"],
["Pune Temple Darshan Sedan Cab", "Pune Family Tour Sedan Cab"],
["Pune Tourist Places Sedan Cab", "Pune Private Sedan Cab Booking"],
["Pune Full Day Sedan Cab Service", "Pune Weekend Sightseeing Sedan Cab"],
["Pune Darshan Cab Service", "Pune Sightseeing Taxi Service"],
["Pune City Tour Cab Booking", "Pune Tourist Cab Service"],
["Pune Sedan Taxi Service", "Maruti Suzuki Dzire for Pune Darshan"],
["Hyundai Aura for Pune Darshan", "Honda Amaze for Pune Darshan"],
["Sedan Taxi for Pune Sightseeing", "AC Sedan Cab for Pune Tour"],
["Budget Sedan Cab Pune Darshan", "Premium Sedan Taxi Pune"],
["Executive Sedan Cab Pune", "Sedan Cab for Family Tour Pune"],
["Sedan Cab for Tourist Places Pune", "Pune Darshan Sedan Cab Booking"]
],



whychoose: [
  {
    WhyChooseheading: "Pune Darshan Sedan Cab for Convenient City Sightseeing",
    WhyChoosedescription: "Garud Cab Service provides sedan cab booking for Pune Darshan, allowing families, couples, senior citizens, and small groups to explore important attractions across Pune in a private and comfortable vehicle."
  },
  {
    WhyChooseheading: "Personalized Pune Sightseeing Experience",
    WhyChoosedescription: "Plan your Pune Darshan according to your preferred places and available time instead of following a fixed group-tour schedule, giving you greater flexibility throughout the day."
  },
  {
    WhyChooseheading: "Comfortable Sedan for Small Groups",
    WhyChoosedescription: "A sedan is a practical choice for couples, families, and small groups who want comfortable seating, private transportation, and sufficient space for personal belongings during sightseeing."
  },
  {
    WhyChooseheading: "Visit Pune's Historical & Cultural Attractions",
    WhyChoosedescription: "Your sightseeing plan can include popular attractions such as Shaniwar Wada, Aga Khan Palace, Sinhagad Fort, Pataleshwar Cave Temple, Lal Mahal, and other places based on your selected itinerary."
  },
  {
    WhyChooseheading: "Flexible Pickup from Your Preferred Location",
    WhyChoosedescription: "Start your Pune Darshan directly from your home, hotel, railway station, office, or another convenient location, making it easier to organize your sightseeing schedule."
  },
  {
    WhyChooseheading: "Suitable for Senior Citizens & Families",
    WhyChoosedescription: "Private cab travel offers a more relaxed sightseeing experience for families and senior citizens, with the flexibility to take breaks and adjust the schedule according to individual needs."
  },
  {
    WhyChooseheading: "Half-Day, Full-Day & Customized Plans",
    WhyChoosedescription: "Choose a sightseeing duration based on your plans, whether you want a shorter city tour or a full-day Pune Darshan covering several historical, cultural, and religious attractions."
  },
  {
    WhyChooseheading: "Simple Booking with Garud Cab Service",
    WhyChoosedescription: "Share your preferred pickup point, sightseeing date, passenger count, places you want to visit, and required duration with Garud Cab Service to arrange your Pune Darshan sedan."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune Darshan Sedan Cab Booking?",
    answer: "Yes, Garud Cab Service provides sedan cab booking for Pune Darshan, local sightseeing, family tours, senior citizens, couples, and small groups."
  },
  {
    question: "Can I customize my Pune Darshan itinerary?",
    answer: "Yes, you can discuss your preferred sightseeing places and create an itinerary according to your available time and travel requirements."
  },
  {
    question: "Which places can I visit during Pune Darshan?",
    answer: "You can plan visits to attractions such as Shaniwar Wada, Aga Khan Palace, Sinhagad Fort, Pataleshwar Cave Temple, Lal Mahal, and other suitable Pune destinations."
  },
  {
    question: "Is a sedan suitable for Pune sightseeing?",
    answer: "Yes, a sedan is a convenient option for couples, families, and small groups who prefer private and comfortable transportation for city sightseeing."
  },
  {
    question: "Can senior citizens book a Pune Darshan sedan?",
    answer: "Yes, private sedan travel can be a comfortable option for senior citizens because the itinerary can be arranged with flexible timings and suitable rest breaks."
  },
  {
    question: "Can I get pickup from my hotel in Pune?",
    answer: "Yes, pickup can be arranged from your hotel, home, office, railway station area, or another preferred location in Pune."
  },
  {
    question: "Can I book a half-day Pune Darshan cab?",
    answer: "Yes, half-day sightseeing arrangements can be discussed according to the number of places you want to visit and your preferred travel schedule."
  },
  {
    question: "Is a full-day Pune Darshan package available?",
    answer: "Yes, full-day sedan cab arrangements can be planned for travellers who want to cover multiple attractions during their Pune sightseeing tour."
  },
  {
    question: "Can families book a private Pune Darshan cab?",
    answer: "Yes, families can book a dedicated sedan according to their passenger count and sightseeing requirements."
  },
  {
    question: "How can I book a Pune Darshan Sedan Cab?",
    answer: "Share your pickup location, sightseeing date, passenger count, preferred attractions, and required duration with Garud Cab Service to arrange your Pune Darshan sedan booking."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Vikram Joshi",
    feedback: "We booked a sedan for Pune Darshan with our parents. The private cab allowed us to visit the places we wanted without rushing through the sightseeing schedule.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Radhika More",
    feedback: "Our family planned a full-day Pune sightseeing tour and booked a sedan cab. The vehicle was comfortable and the flexible itinerary made the day enjoyable.",
    rating: 5
  }
];


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Darshan Sedan Cab Booking",
  "image": "https://garudcabs.com/assets/images/pune-darshan-sedan-cab-booking.webp",
  "description": "Book Pune Darshan Sedan Cab Booking with Garud Cab for comfortable and convenient Pune sightseeing. Explore popular city attractions with an air-conditioned Sedan cab suitable for families, couples, and small groups. Get reliable Pune Darshan, Pune sightseeing, and city tour cab services with convenient pickup and drop options.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-darshan-sedan-cab-booking"
  }
};




  return (
    <div>
<Helmet>
  <title>Pune Darshan Sedan Cab Booking | City Tour Taxi | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune Darshan Sedan Cab with Garud Cab for comfortable city sightseeing and Pune Darshan tours. Get reliable Sedan cab booking for Pune sightseeing, city tours, family trips, and local attractions with convenient pickup and drop."
  />

  <meta
    name="keywords"
    content="Pune Darshan Sedan Cab Booking, Pune Darshan Sedan Cab, Pune Sightseeing Sedan Cab, Pune City Tour Sedan Cab, Pune Darshan Cab Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/37.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punedarshansedancabbooking;